import type { ReactNode } from 'react';

/** 面板里一行字段：左标签右控件。 */
export function Field({ label, children, inline }: { label: ReactNode; children: ReactNode; inline?: boolean }) {
  if (inline) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
        <span style={{ fontSize: 12, color: '#555' }}>{label}</span>
        <div>{children}</div>
      </div>
    );
  }
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontSize: 12, color: '#555', marginBottom: 4 }}>{label}</div>
      {children}
    </div>
  );
}
